import { IMAGES } from "./business";

// The three service areas JK House Cleaning covers.
export const SERVICE_AREAS = [
  {
    name: "West Melbourne",
    blurb:
      "Reliable, detail-focused house cleaning for homes and apartments across West Melbourne.",
    image: IMAGES.melbourneStreet,
  },
  {
    name: "East Melbourne",
    blurb:
      "Premium residential cleaning for East Melbourne houses, townhouses and apartments.",
    image: IMAGES.livingBright,
  },
  {
    name: "North Melbourne",
    blurb:
      "Professional, dependable home cleaning for North Melbourne residents.",
    image: IMAGES.livingOpen,
  },
];

// Plain list of the area names for natural inline copy and schema.
export const SERVICE_AREA_NAMES = SERVICE_AREAS.map((a) => a.name);
